export default function OrDivider() {
  return (
    <div
      data-testid='or-divider'
      className='flex items-center gap-2 md:flex-col md:self-stretch md:px-1'
    >
      <span className='h-px flex-1 bg-gray-300 md:h-auto md:w-px' />
      <span className='text-[10.5px] font-bold uppercase tracking-widest text-gray-400'>
        OR
      </span>
      <span className='h-px flex-1 bg-gray-300 md:h-auto md:w-px' />
    </div>
  );
}
